export default function SuperDashboard() {
  return <div className='w-full flex'>Logged in dashboard</div>;
}
